import {inFirstHalf} from "games/gameArm";
import type {UpgradeMomentId} from "./upgradeMoments";

/**
 * Which half of an upgrade moment's own A/B test a visitor is in (kitecorp/transferify-ui#2909) —
 * React-free.
 *
 * Each moment is its own 50/50 test against a control that sees nothing new, split the way the transfer
 * games split (`games/gameArm`): derived from the analytics client id, so it is stable across visits
 * and needs no storage of its own, with the moment's own experiment name as the salt. A visitor without
 * an id draws a group for the page load; no event leaves their browser, so they are not in the results.
 */
export type MomentArm = "prompt" | "control";

/** The experiment names, which are also the `moment` parameter of `UPGRADE_MOMENT_ELIGIBLE`. */
export const MOMENT_EXPERIMENTS: Record<UpgradeMomentId, string> = {
	unpaidLimit: "unpaid_limit",
	bigFiles: "big_files",
	repeatRecipient: "repeat_recipient",
	sendingDays: "sending_days",
};

export function momentArm(moment: UpgradeMomentId, clientId: string | null, random: () => number): MomentArm {
	const first = clientId === null ? random() < 0.5 : inFirstHalf(clientId, `upgrade_moment_${MOMENT_EXPERIMENTS[moment]}`);
	return first ? "prompt" : "control";
}
